import {DatePicker as AntdDatePicker, DatePickerProps} from "antd";
import dayjs from "dayjs";
import {RangePickerProps} from "antd/es/date-picker";

function convertToDayjs(value: any) {
    if (!value) {
        return null;
    }
    return dayjs.isDayjs(value) ? value : dayjs(value);
}

function DatePicker(props: DatePickerProps) {
    const newProps = {...props};
    newProps.value = convertToDayjs(props.value);
    return <AntdDatePicker {...newProps}/>
}

function DateRangePicker(props: RangePickerProps) {
    const newProps = {...props};
    newProps.value = (newProps.value?.map(i => convertToDayjs(i))) as any
    return <AntdDatePicker.RangePicker {...newProps} />
}

DatePicker.RangePicker = DateRangePicker

export default DatePicker;
